import React from 'react';
import PropTypes from 'prop-types';
import { Footer, FooterButton } from './modalFooterStyles';

const ModalFooter = ({
	dismiss, checkoutUrl
}) => {
	return (
		<Footer>
			<FooterButton onClick={dismiss} themeType="stroke">Continue Shopping</FooterButton>
			<FooterButton href={checkoutUrl}>Proceed to Checkout</FooterButton>
		</Footer>
	);
};

ModalFooter.propTypes = {
	dismiss: PropTypes.func,
	checkoutUrl: PropTypes.string,
};

ModalFooter.defaultProps = {};

export default ModalFooter;
